import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFormSettings = (moduleName, fetchSettingsAction) => {
    const dispatch = useDispatch();
    const { settings, isSettingsInitialized } = useSelector((state) => state[moduleName]);
    const [isLoadingSettings, setIsLoadingSettings] = useState(false);
    const isSettingsLoading = useRef(false);

    useEffect(() => {
        const loadSettings = async () => {
            if (!isSettingsInitialized && !isSettingsLoading.current) {
                isSettingsLoading.current = true;
                setIsLoadingSettings(true);
                try {
                    await dispatch(fetchSettingsAction());
                } catch (error) {
                    console.error(`Error loading ${moduleName} settings:`, error);
                } finally {
                    setIsLoadingSettings(false);
                    isSettingsLoading.current = false;
                }
            }
        };

        loadSettings();
    }, [dispatch, isSettingsInitialized, moduleName, fetchSettingsAction]);

    return {
        settings,
        isSettingsInitialized,
        isLoadingSettings
    };
};

export default useFormSettings; 